import { render, staticRenderFns } from "./TransactionError.vue?vue&type=template&id=5121450f"
import script from "./TransactionError.vue?vue&type=script&lang=js"
export * from "./TransactionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports